<template>
  <modal
    size="medium"
    close-on-click-outside
    active
    class="voice-edit-history-modal"
    @onClose="onClose()">
    <div slot="header">Edit History (DwV)</div>
    <div slot="content">
      <dispute-activities :activities="editHistory"></dispute-activities>
    </div>
  </modal>
</template>

<script>
import DisputeActivities from "@/components/DisputeActivities/DisputeActivities.vue";

export default {
  name: "VoiceDisputeEditHistoryModal",
  components: {
    DisputeActivities,
  },
  props: {
    editHistory: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onClose() {
      this.$emit("onModalClose");
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/imports";
.voice-edit-history-modal {
  .modal--medium {
    width: 948px;
    height: 600px;
  }
}
</style>
